import { useState, ReactNode, useEffect } from "react";
import { matchPath, useLocation } from "react-router-dom";
import { ToastContainer, Zoom } from "react-toastify";
import SideNav from "./SideNav";
import TopNav from "./TopNav";
import { currentYear } from "../../helpers";
interface Props {
  children: ReactNode;
}
const Layout = (props: Props) => {
  const [showMenu, setShowMenu] = useState(false);

  const toggleMenu = () => {
    setShowMenu(!showMenu);
  };

  const location = useLocation();
  const { children } = props;

  const [pageTitle, setPageTitle] = useState("Global Product Hierarchy");

  const titleMap = [
    { path: "/", title: "Global Product Hierarchy" },
    { path: "/admin", title: "Global Product Hierarchy - Logs" },
    { path: "/edit/:type/:id", title: "Global Product Hierarchy - Edit" },
    { path: "/create-new", title: "Global Product Hierarchy - Create" },
    { path: "/user-guide", title: "Global Product Hierarchy - User Guide" },
    { path: "/no-access", title: "Not authorized" },
    { path: "/*", title: "Not Found" },
  ];

  const route = titleMap.find((item) =>
    matchPath(item.path, location.pathname)
  );

  useEffect(() => {
    if (route && route.title) {
      setPageTitle(route.title);
      document.title = route.title;
    }
  }, [route]);

  return (
    <div>
      {/* Page Wrapper */}
      <div id="wrapper">
        <SideNav toggle={toggleMenu} showMenu={showMenu} />

        {/* Content Wrapper */}
        <div id="content-wrapper" className="d-flex flex-column">
          {/* Main Content */}
          <div id="content">
            <TopNav toggle={toggleMenu} title={pageTitle} />
            <div id="modal-container" className="pt-0">
              {/* Begin Page Content */}
              <div id="main-content" className="container-fluid">
                <ToastContainer
                  hideProgressBar
                  newestOnTop
                  draggable={false}
                  theme="colored"
                  transition={Zoom}
                />
                {children}
              </div>
            </div>
            {/* /.container-fluid */}
          </div>
          {/* End of Main Content */}

          {/* Footer */}
          <footer className="sticky-footer bg-white">
            <div className="container my-auto">
              <div className="copyright text-center my-auto">
                <span>Copyright &copy; Tupperware {currentYear}</span>
              </div>
            </div>
          </footer>
          {/* End of Footer */}
        </div>
        {/* End of Content Wrapper */}
      </div>
      {/* End of Page Wrapper */}
    </div>
  );
};

export default Layout;
